import { computed } from "vue";
import { useStore } from "vuex";

export default () => {
  const store = useStore();
  const getCustomerAuths = computed(() => store.getters.getCustomerAuths);
  const isCustomerPower = (code: number) => {
    if (store.getters.getUserinfo("userType") == 1) {
      return true;
    }
    if (getCustomerAuths.value?.length) {
      return getCustomerAuths.value?.findIndex((m: Record<string, any>) => m.permissionCode == code) > -1;
    }
    return false;
  };

  return isCustomerPower;
};
